<div class="log-action-shortcuts" *ngIf="permissions.postActivity">
    
    <button type="button" class="btn btn-primary btn-sm shortcut-action-btn" translate="logACall" (click)="logCall()">Log a Call</button>
    <button type="button" class="btn btn-primary btn-sm shortcut-action-btn" translate="logANote" (click)="logNote()">Log a Note</button>
    <button type="button" class="btn btn-primary btn-sm shortcut-action-btn" translate="scheduleAppt" (click)="scheduleAppt()">Schedule Appt</button>
    <email-template-action [opportunity]="opportunity" [isEuroLite]="false" [permissions]="permissions" isShortcutButton="true"></email-template-action>
    <text-action [opportunity]="opportunity" [isTextingEnabled]="isTextingEnabled" isShortcutButton="true" isCustomerConnectOpen="true"></text-action>

</div>
